export default {"src":"/_next/static/media/progress-indicator.8ff709be.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};